/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const searchChallengeV2ResultSchema = z.object({
  id: z.number(),
  title: z.string(),
  cefrLevel: z.string(),
  type: z.string(),
  slug: z.string(),
});

export type ISearchChallengeV2Result = z.infer<typeof searchChallengeV2ResultSchema>;

export const searchChallengesV2ResponseSchema = createApiResponseSchema(
  z.array(searchChallengeV2ResultSchema),
) as z.ZodSchema<IAPI<ISearchChallengeV2Result[]>>;

export type ISearchChallengesV2Response = IAPI<ISearchChallengeV2Result[]>;
